<template>
  <b-standard-card
    :title="translations.title[lang]"
    height="auto"
    class="mt-5"
    :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
    :loading="loading"
    :error-message="errorMessage"
    @submit="updateDisplayMode({ type: 'display_mode', body: { display_mode: newMode } })"
  >
    <v-row no-gutters justify="space-between" align="center">
      <v-col cols="6">
        <v-select
          :items="options"
          item-text="text"
          item-value="value"
          :label="translations.rewardDisplay[lang]"
          v-model="newMode"
          dense
          outlined
        ></v-select>
      </v-col>
    </v-row>
  </b-standard-card>
</template>

<script>
import translations from '@/utils/translations/loyaltyPanel/businessProfile/displayMode';
import { mapActions } from 'vuex';

export default {
  name: 'DisplayMode',

  mixins: [translations],
  data() {
    return {
      newMode: '',
    };
  },

  computed: {
    lang() {
      return this.$route.params.lang;
    },
    loading() {
      return this.$store.state.loyaltyPanel.businessProfile.loading.display_mode;
    },
    errorMessage() {
      return this.$store.state.loyaltyPanel.businessProfile.errorMessage.display_mode;
    },
    storeMode() {
      return this.$store.state.store.display_mode || 'points';
    },
    options() {
      return [
        { value: 'points', text: this.translations.points[this.lang] },
        { value: 'cashback', text: this.translations.cashback[this.lang] },
      ];
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/businessProfile', ['updateDisplayMode']),
  },
  watch: {
    storeMode: {
      immediate: true,
      handler(val) {
        this.newMode = val;
      },
    },
  },
};
</script>
